import { createRoute, redirect, Outlet } from '@tanstack/react-router'
import { rootRoute } from './__root'

/**
 * Onboarding route layout - authenticated but WITHOUT onboarding guard
 *
 * This prevents infinite redirect loops when users are going through
 * the onboarding flow.
 */
export const onboardingRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_onboarding',
  beforeLoad: ({ context }) => {
    if (!context.isAuthenticated) {
      throw redirect({
        to: '/login',
      })
    }
  },
  component: () => <Outlet />,
})
